'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Favorite = require('./Favorite');

var _Favorite2 = _interopRequireDefault(_Favorite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Favorite2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Favorite/index.js
// module id = 171
// module chunks = 0